import { atom } from 'jotai'

export const featureFlagsFetchedAtom = atom(false)
